RivalIQ.apps.Insights.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const config = [
        {
            name: 'top',
            sizes: {
                md: 12
            },
            page: 0
        },
        {
            name: 'posts',
            sizes: {
                md: 12
            },
            page: 1
        },
        [
            {
                name: 'activity-impressions',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            },
            {
                name: 'hashtags',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            }
        ],
        [
            {
                name: 'keywords',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 3
            },
            {
                name: 'post-tags',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 3
            }
        ],
        {
            name: 'by-type',
            sizes: {
                md: 12
            },
            page: 4
        },
        {
            name: 'time-usage',
            sizes: {
                md: 12
            },
            page: 5
        }
    ];

    curations.FacebookInsightsPostsCuration = curations._BaseFacebookInsightsCuration.extend({

        widgetsView: App.views.InsightsLayout.extend({
            config: config
        }),
        widgetView: App.views.InsightsDetailsLayout,

        exportTitle: 'Facebook Post Insights',

        processProps: function (props) {
            const me = this;

            props.objectType = 'post';

            return curations._BaseLinkedInInsightsCuration.prototype.processProps.apply(me, arguments);
        },

        loadConfiguration: function () {
            const me = this;
            return RivalIQ.data.configuration.fetch(me, me.getProps());
        }
    });

});
